import React, { useEffect, useMemo, useState } from 'react';
import BreadCrumb from '../../components/BreadCrumb';
import {
  Wrapper,
  SkeletonWrapper,
  Title,
  Subtitle,
  DetailContent,
  SubWrapper,
  Subtitle2,
  TitleWrapper,
  IconAlert,
  FooterContent,
  Link,
  IconBack,
  Container2,
  Subtitle2Area,
  CalcButton,
} from './styles';

import { FiFileText } from 'react-icons/fi';
import { BiCalendar } from 'react-icons/bi';
import { useDispatch, useSelector } from 'react-redux';
import {
  getNegotiationDetails,
  confirmNegotiation,
  // setForceRecalculation,
} from '../../store/negotiation/actions';
import { page } from '../../store/auth/actions';
import { useHistory, useLocation } from 'react-router-dom';
import { navigationUrl } from '../../store/analytic/actions';
import moment from 'moment';
import ModalContracts from '../../components/Modal/Contracts';
import ModalClaimPayment from '../../components/Modal/ClaimPayment';
import formatPrice from '../../services/utils/formatPrice';
import Skeleton from 'react-loading-skeleton';
import { getContractsFromDealOrDebt } from '../../utils/getContractsToShow';
import getOriginalContract from '../../utils/getOriginalContract';
import getContractDescription from '../../utils/getContractDescription';
import NegotiationList from '../../components/NegotiationList';
import InputDatePicker from './DatePickerNegotiation';

type NegotiationProps = {
  contract: GQL.IDebt;
};

const Negotiation: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [date, setDate] = useState(new Date());
  const [allowDate, setAllowDate] = useState(false);

  const [openClaimPayment, setOpenClaimPayment] = useState(false);
  const location = useLocation<NegotiationProps>();
  const contract: GQL.IDebt = location.state && location.state.contract;
  const history = useHistory();
  const dispatch = useDispatch();

  const { negotiationLoading, list, forceRecalculation } = useSelector(
    (state: ApplicationState) => ({
      list: state.negotiation.list,
      negotiationLoading: state.negotiation.negotiationLoading,
      forceRecalculation: state.negotiation.forceRecalculation,
    })
  );
  const { allowProjectionDate, allowsOptionsRecalculation } = useMemo(
    () => ({
      allowProjectionDate: list.some((obj) => obj.allowProjectionDate),
      allowsOptionsRecalculation: list.some(
        (obj) => obj.allowsOptionsRecalculation
      ),
    }),
    [list]
  );
  const [allowRecalculation, setAllowRecalculation] = useState<boolean | null>(
    false
  );

  const contractsToShow = useMemo(() => getContractsFromDealOrDebt(contract), [
    contract,
  ]);

  useEffect(() => {
    dispatch(confirmNegotiation.failure(null)); //cleaning confirmationInfos
  }, [dispatch]);

  useEffect(() => {
    setAllowRecalculation(allowsOptionsRecalculation);
    setAllowDate(allowProjectionDate);
  }, [allowProjectionDate, allowsOptionsRecalculation]);

  useEffect(() => {
    if (contract) {
      dispatch(
        getNegotiationDetails.request({
          databaseId: contract.databaseId,
          contract: contract.contracts,
          creditorId: contract.creditorId,
          forceRecalculation: /* (allowRecalculation && */ forceRecalculation /* )  as boolean */,
          projectionDueDate: moment(date.toString()).format('YYYY-MM-DD'),
        })
      );
      dispatch(page('contrato'));
      dispatch(
        navigationUrl.request({
          action: '/negociacao',
          creditor: contract.creditorName,
          dealValue: contract.updatedValue,
          dealType: contract.proposalType,
          delay: contract.longerDelay,
        })
      );
    } else {
      history.push('/contrato');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    contract,
    history,
    // allowRecalculation,
    // forceRecalculation,
    // allowDate,
    date,
  ]);

  const recalculate = (): void => {
    dispatch(
      getNegotiationDetails.request({
        databaseId: contract.databaseId,
        contract: contract.contracts,
        creditorId: contract.creditorId,
        forceRecalculation: true,
        projectionDueDate: moment(date.toString()).format('YYYY-MM-DD'),
      })
    );
    // dispatch(setForceRecalculation.request(true));
  };

  const handlerClose = (): void => {
    setOpen(false);
  };

  const handlerOpen = () => {
    setOpen(true);
  };

  const handlerCloseClaimPayment = (): void => {
    setOpenClaimPayment(false);
  };

  const handlerOpenClaimPayment = () => {
    setOpenClaimPayment(true);
  };
  const handleDateValue = (e: any) => {
    setDate(e);
  };
  return (
    <Wrapper>
      <Container2>
        <TitleWrapper>
          <IconBack onClick={() => history.goBack()} />
          <Title>Meu Débito</Title>
          <BreadCrumb
            currentPage='Meu Débito'
            previouPages={[{ name: 'Débitos e Acordos', route: '/contrato' }]}
            showBreadCrumbOnMinWidth='960px'
          />
        </TitleWrapper>
        <SubWrapper>
          <Subtitle>
            Valor da dívida: R$ {contract && formatPrice(contract.updatedValue)}
          </Subtitle>
          <DetailContent style={{ width: '100%' }}>
            <div className='bank-name'>
              <span>{contract && contract.creditorName}</span>
            </div>
            <div className='default'>
              <FiFileText className='space-right' />
              {contract && contract.contracts.length > 1
                ? `Múltiplos contratos: `
                : `Contrato: `}
              {contract && contract.contracts.length === 1 && (
                <strong className='space-left'>
                  {contractsToShow && getOriginalContract(contractsToShow[0])}
                </strong>
              )}

              <Link onClick={() => handlerOpen()}>
                {'  Detalhar dívida(s)'}
              </Link>
            </div>
            {contract && contract.proposalDueDate && (
              <div className='default'>
                <BiCalendar className='space-right' />
                Vencimento da entrada:{' '}
                <span>
                  <strong>
                    {moment(contract && contract.proposalDueDate).format(
                      'DD/MM/YYYY'
                    )}
                  </strong>
                </span>
              </div>
            )}
            {contract && contract.contracts.length === 1 && (
              <span className='default' style={{ marginBottom: 0 }}>
                {getContractDescription(contractsToShow[0])}
              </span>
            )}
            {allowDate && (
              <div className='datepicker-box'>
                Alterar vencimento da entrada:{' '}
                <InputDatePicker value={date} Onchange={handleDateValue} />{' '}
              </div>
            )}
          </DetailContent>

          <Subtitle2Area>
            <Subtitle2>OPÇÕES DE PAGAMENTO</Subtitle2>
            {allowRecalculation && (
              <CalcButton onClick={recalculate}>Recalcular Opções</CalcButton>
            )}
          </Subtitle2Area>

          {negotiationLoading ? (
            <Wrapper>
              <SkeletonWrapper>
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
                <Skeleton className='option' style={{ borderRadius: '60px' }} />
              </SkeletonWrapper>
            </Wrapper>
          ) : (
            <NegotiationList list={list} contract={contract} />
          )}

          <FooterContent>
            <IconAlert className='alert-proposal-icon' />
            <div className='footer'>
              <span>
                Caso este valor já tenha sido regularizado, por favor alegue
                pagamento{' '}
                <Link onClick={() => handlerOpenClaimPayment()}>
                  clicando aqui.
                </Link>
              </span>
            </div>
          </FooterContent>
        </SubWrapper>

        {open && (
          <ModalContracts
            handlerClose={handlerClose}
            contracts={contractsToShow}
          />
        )}
        {openClaimPayment && (
          <ModalClaimPayment
            databaseId={contract.databaseId}
            contracts={contract && contract.contracts}
            handlerClose={handlerCloseClaimPayment}
          />
        )}
      </Container2>
    </Wrapper>
  );
};

export default Negotiation;
